// @ts-nocheck

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { notification } from "antd";
import { http } from "../../../engine/api/http";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import routes from "../../../engine/routes";
import { useNavigate, useParams } from "react-router-dom";

const initialState = {
  users: [],
  log: {
    _id: undefined,
    customerId: "",
    baseUrl: "",
    route: "",
    method: "",
    entityId: "",
    user: null,
    userAgent: "",
    ipAddress: "",
    content: null,
  },
  loading: false,
};

export const getLog = createAsyncThunk(
  "log/getLog",
  async (logId, thunkAPI) => {
    const res = await http.get("/logs/" + logId);
    return res.data;
  },
);

const logSlice = createSlice({
  name: "log",
  initialState,
  reducers: {
    clearLog: state => {
      return initialState;
    },
  },
  extraReducers: {
    [getLog.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getLog.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.log = payload;
    },
    [getLog.rejected]: state => {
      state.loading = false;
    },
  },
});

export const initLogSlice = ({}) => {
  const dispatch = useDispatch();

  const { id } = useParams();

  const { log, loading } = useSelector(state => state.log);
  const navigate = useNavigate();

  const init = async () => {
    await dispatch(getLog(id));
  };

  const clear = async () => {
    await dispatch(clearLog());
  };

  useEffect(() => {
    if (log._id !== undefined && log._id !== id) {
      navigate(routes.logs(log._id).detail.path, {
        replace: true,
      });
    }
  }, [log]);

  useEffect(() => {
    const allAwait = async () => {
      await init();
    };

    allAwait();

    return () => {
      clear();
    };
  }, []);

  return { init, clear };
};

export const { clearLog, setPropertiesLog } = logSlice.actions;

export const logReducer = logSlice.reducer;
